import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { MainContainer } from '@core/Components/Containers'
import { ProfileDisplay } from '@core/Areas/BetLoop/Components/ProfileDisplay'
import { betLoopPrincipleProfileQuery } from '@core/Areas/BetLoop/helpers/queries'

export const MyProfilePage: React.FC = () => {
  const { data: profile, isPending: isFetchingProfile } = useQuery(betLoopPrincipleProfileQuery)

  if (isFetchingProfile) {
    // TODO: Replace with skeleton loader
    return null
  }

  if (!profile) {
    // TODO: Send the user back to the root feed page and have a toast message read "This profile does not exist"
    return <div>Error: No profile found</div>
  }

  return (
    <MainContainer background='surface300'>
      <ProfileDisplay isMyProfile profile={profile} />
    </MainContainer>
  )
}
